import { Box, Typography } from '@mui/material'
import FormSubmissionsList from 'src/pages/FormsLandingPage/FormSubmissionsList'
import { FormTemplate } from 'types/graphql'

interface SubmissionsTabProps {
  formTemplate: FormTemplate
}

const SubmissionsTab = ({ formTemplate }: SubmissionsTabProps) => {
  return (
    <Box sx={{ py: 2 }}>
      <Typography variant="h6" sx={{ mb: 2 }}>
        Form Submissions
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        View and manage all submissions for &quot;{formTemplate.title}&quot;
      </Typography>

      <FormSubmissionsList formTemplateId={formTemplate.id} />
    </Box>
  )
}

export default SubmissionsTab
